import React, { useState, useEffect } from 'react';
import { getSystemByCode } from '../api/systemsApi';

const SystemTooltip = ({ element, x, y }) => {
    const [systemInfo, setSystemInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadSystemInfo = async () => {
            const code = element?.systemCode || element?.parentSystemCode || element?.code;
            if (!code) {
                setLoading(false);
                return;
            }

            try {
                console.debug('[SystemTooltip] fetching system by code:', code);
                const info = await getSystemByCode(code);
                console.debug('[SystemTooltip] fetch result:', info);
                setSystemInfo(info);
            } catch (error) {
                console.error('Failed to load system info:', error);
            } finally {
                setLoading(false);
            }
        };

        loadSystemInfo();
    }, [element]);

    if (!element || (!element.systemCode && !element.parentSystemCode)) {
        return null;
    }

    if (loading) {
        return (
            <div
                style={{
                    position: 'absolute',
                    left: x + 10,
                    top: y + 10,
                    background: 'rgba(0, 0, 0, 0.85)',
                    color: '#fff',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    zIndex: 2000,
                    pointerEvents: 'none',
                    maxWidth: '300px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}
            >
                Загрузка...
            </div>
        );
    }

    if (!systemInfo) {
        return (
            <div
                style={{
                    position: 'absolute',
                    left: x + 10,
                    top: y + 10,
                    background: 'rgba(239, 68, 68, 0.9)',
                    color: '#fff',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    zIndex: 2000,
                    pointerEvents: 'none',
                    maxWidth: '300px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}
            >
                Система не найдена: {element.systemCode || element.parentSystemCode}
            </div>
        );
    }

    return (
        <div
            style={{
                position: 'absolute',
                left: x + 10,
                top: y + 10,
                background: 'rgba(0, 0, 0, 0.85)',
                color: '#fff',
                padding: '10px 14px',
                borderRadius: '8px',
                fontSize: '13px',
                zIndex: 2000,
                pointerEvents: 'none',
                maxWidth: '320px',
                boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
                backdropFilter: 'blur(4px)'
            }}
        >
            <div style={{ fontWeight: 'bold', marginBottom: '6px', fontSize: '14px', color: '#60a5fa' }}>
                {systemInfo.name}
            </div>
            <div style={{ marginBottom: '4px' }}>
                <span style={{ opacity: 0.7 }}>Код:</span> <strong>{systemInfo.code}</strong>
            </div>
            <div style={{ marginBottom: '4px' }}>
                <span style={{ opacity: 0.7 }}>Тип:</span> {systemInfo.type === 'system' ? 'Система' : 'Модуль'}
            </div>
            {systemInfo.description && (
                <div style={{ marginTop: '6px', paddingTop: '6px', borderTop: '1px solid rgba(255,255,255,0.2)', fontSize: '12px', opacity: 0.9 }}>
                    {systemInfo.description.length > 100
                        ? systemInfo.description.substring(0, 100) + '...'
                        : systemInfo.description}
                </div>
            )}
            <div style={{ marginTop: '8px', fontSize: '11px', opacity: 0.6, fontStyle: 'italic' }}>
                ПКМ → Перейти для подробностей
            </div>
        </div>
    );
};

export default SystemTooltip;
